import { EBuildingHeatingType } from '../../../../json_query';
import { changeBuildingHeating } from '../../../state/advanced/building_heating';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const BuildingHeating = getMultiSelectParam<EBuildingHeatingType>(
  'Отопление',
  [
    { title: 'Автономное', value: EBuildingHeatingType.Autonomous },
    { title: 'Центральное', value: EBuildingHeatingType.Central },
    { title: 'Нет', value: EBuildingHeatingType.Without },
  ],
  'building_heating_type',
  changeBuildingHeating,
);
